import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'light',
  language: 'en',
  loggedInUserData: {},
  userSettingsResponse: {},
  isAdmin: false,
  isLoggedInAsAdmin: true,
  staffManagement: {
    addStaffTab: {
      selectedTab: 'personalInformation'
    }
  }
};

const currentUserSlice = createSlice({
  name: 'currentUserSlice',
  initialState,
  reducers: {
    setUserTheme: (state, action) => {
      state.theme = action.payload;
    },
    setUserLanguage: (state, action) => {
      state.language = action.payload;
    },
    setLoggedInUserData: (state, action) => {
      state.loggedInUserData = action.payload;
    },
    setUserSettingResponse: (state, action) => {
      state.userSettingsResponse = action.payload;
    },
    setStaffManagementSelectedTab: (state, action) => {
      state.staffManagement.addStaffTab.selectedTab = action.payload
    },
    addStaffManagementTab: (state, action) => {
      state.staffManagement.addStaffTab.tablist = [...state.staffManagement.addStaffTab.tablist, action.payload]
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action?.payload
    },
    setIsLoggedInAsAdmin: (state, action) => {
      state.isLoggedInAsAdmin = action?.payload
    }
  },
});

export const {
  setUserLanguage,
  setUserTheme,
  setLoggedInUserData,
  setUserSettingResponse,
  setStaffManagementSelectedTab,
  addStaffManagementTab,
  setIsAdmin,
  setIsLoggedInAsAdmin
} = currentUserSlice.actions;
export default currentUserSlice.reducer;
